import lovingWhatIs from "../constants/demos/loving-what-is.jpg";
import adultChildren from "../constants/demos/adult-children.jpg";
import bodyScore from "../constants/demos/body-score.jpg";
import outFog from "../constants/demos/out-fog.jpg";
import narcissist from "../constants/demos/narcissist.jpg";
import dangerousMan from "../constants/demos/dangerous-man.jpg";
import healing from "../constants/demos/healing-relationships.jpg";
import untethered from "../constants/demos/untethered-soul.jpg";

const introduction = [
  "Whether you're navigating tough times or seeking additional support, I'm here to help! With over 20 years of experience as a licensed clinical social worker, I've had the privilege of working with families, individuals, couples, and veterans. My goal is to create a safe and nurturing space where we can cultivate patience, understanding, and acceptance together. I utilize a variety of therapeutic approaches, including cognitive behavioral therapy, motivational interviewing, group psychotherapy, the social information processing model, and interpersonal psychotherapy, among others. My extensive experience in end-of-life care has given me a unique perspective on life's challenges, and I believe that life's most impactful moments often arise from intense pain. Together, we can find hope and discover that our best days are still ahead. Let's begin this journey together!",
];

const books = [
  {
    title: "Loving What Is",
    author: "Byron Katie with Stephen Mitchell",
    synopsis:
      "Four questions that can change your life.  A book that teaches you how to view each situation through a different lens.  Byron Katy says, “It’s not the problem that causes our suffering: It’s our thinking about the problem.”",
    tags: ["Love & Loss", "Personal Growth", "Mindfulness"],
    link: "https://www.amazon.com/Loving-What-Revised-Questions-Change/dp/0593234510/ref=sr_1_1?dib=eyJ2IjoiMSJ9.KPaK8MYhO_JwQ7Dtuyfn3wtpEw-j5mqnE185maZjZWW11jape-LiUyfv3TwYO1Bgp_tOhaLFz4rJJpPX__dM4TQXsBdWMO2xLXqiN4-n4q9mMFqzI1ZPJT7mhd2LwgmjEyWfpscpoNQUIItuki8TNn4mEl7-BG4dKHvUVVlDiT1Njh3ohHYLeqS84EdTEyzd6xnK_UIumtpNZ2iHVrfWYdd3vjZNTvYaGSjxs-Hg2H4.hz5sNwvM0EEmaUCsUZbMfvSYAtWU2tWTREM99uuQE8U&dib_tag=se&hvadid=409951786528&hvdev=c&hvlocphy=9192164&hvnetw=g&hvqmt=e&hvrand=263816056425686596&hvtargid=kwd-424068457404&hydadcr=22592_11320425&keywords=byron+katie+loving+what+is+book&qid=1722450564&sr=8-1",
    demo: lovingWhatIs,
  },
  {
    title: "Adult Children of Emotionally Immature Parents",
    author: "Lindsay C. Gibson, PsyD",
    synopsis:
      "This book delves into the lasting impact of having emotionally immature parents, offering insights into how this affects adult relationships and self-perception. It provides guidance for healing and building healthier, more authentic connections by understanding and addressing childhood wounds.",
    tags: ["Emotional Healing", "Family Dynamics", "Personal Growth"],
    link: "https://www.amazon.com/s?k=adult+children+of+immature+parents&hvadid=598613769006&hvdev=c&hvlocphy=9192164&hvnetw=g&hvqmt=e&hvrand=3744240064401997748&hvtargid=kwd-218609038888&hydadcr=22595_13531227&tag=googhydr-20&ref=pd_sl_59c0o3spl0_e",
    demo: adultChildren,
  },
  {
    title: "The Body Keeps The Score",
    author: "Bessel Van der Kolk, M.D.",
    synopsis:
      "Bessel van Der Kolk has spent over three decades working with survivors  This book works on rewiring the brain. I encourage this book to dive into what is your trauma stress.  Once you identify these traumas, heal, and change outcomes.  Otherwise, you may stay stuck in the same cycles.",
    tags: ["Trauma", "Mental Health", "PTSD Recovery"],
    link: "https://www.amazon.com/Body-Keeps-Score-Healing-Paperback/dp/B083M21V6Y/ref=asc_df_B083M21V6Y/?tag=hyprod-20&linkCode=df0&hvadid=700795211921&hvpos=&hvnetw=g&hvrand=7106209771940295306&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9192164&hvtargid=pla-2325445287521&psc=1&mcid=4b284d06b9cc342185b96f1c06589c7a&gad_source=1",
    demo: bodyScore,
  },
  {
    title: "Out of the Fog",
    author: "Dana Morningstar",
    synopsis:
      "Dana Morningstar does a great job of breaking down healthy and unhealthy relationships.  She offers an easy read of destructive patterns in relationships (couples, families, friendships).  I have worked with many people who report, 'Aha moments’ when they were able to connect with the unhealthy patterns of their partner.  You might feel liberated after reading this book if you have a relationship with a narcissist.",
    tags: ["Relationships", "Emotional Abuse", "Personal Growth"],
    link: "https://www.amazon.com/s?k=out+of+the+fog+by+dana+morningstar&hvadid=598656482056&hvdev=c&hvlocphy=9192164&hvnetw=g&hvqmt=e&hvrand=4857897125440799729&hvtargid=kwd-1178165714855&hydadcr=15555_13558560&tag=googhydr-20&ref=pd_sl_6g10h5lgzv_e",
    demo: outFog,
  },
  {
    title: "How to Kill a Narcissist",
    author: "JH Simon",
    synopsis:
      "Narcissism is an overwhelming and confusing topic.  This book is insightful and offers advice for coping through toxic relationships.",
    tags: ["Emotional Abuse", "Personal Growth", "Toxic Relationships"],
    link: "https://www.amazon.com/s?k=how+to+kill+a+narcissist&hvadid=616931177746&hvdev=c&hvlocphy=9192164&hvnetw=g&hvqmt=e&hvrand=11753086181802599066&hvtargid=kwd-282336630230&hydadcr=24630_13611748&tag=googhydr-20&ref=pd_sl_8bi3wgcoz2_e",
    demo: narcissist,
  },
  {
    title: "How to Spot a Dangerous Man Before You Get Involved",
    author: "Sandra L. Brown, M.A.",
    synopsis:
      "This eye opening book provides an easy to understand read about unhealthy partners.  If you feel like you have a ‘bad picker’ this might be a good read for you.",
    tags: ["Emotional Abuse", "Romantic Relationships", "Personal Safety"],
    link: "https://www.amazon.com/s?k=how+to+spot+a+dangerous+man&hvadid=598656679561&hvdev=c&hvlocphy=9192164&hvnetw=g&hvqmt=e&hvrand=4338128948583245151&hvtargid=kwd-838640675&hydadcr=15527_13558519&tag=googhydr-20&ref=pd_sl_97pwweo2mv_e",
    demo: dangerousMan,
  },
  {
    title: "Healing from Toxic Relationships",
    author: "Stephanie Moulton Sarkis, PhD",
    synopsis:
      "Gaslighting, Narcissism and emotional destructive relationships can be difficult to move on from even years after the relationship ends.  This is a great book to help healing and how to avoid toxic individuals in the future.",
    tags: ["Emotional Abuse", "Personal Growth", "Toxic Relationships"],
    link: "https://www.amazon.com/Healing-Toxic-Relationships-Gaslighting-Narcissism/dp/0306847256",
    demo: healing,
  },
  {
    title: "The Untethered Soul",
    author: "Michael A. Singer",
    synopsis:
      "Michael Singer shows you how to live in the present moment being your true self and finding inner happiness and peace.",
    tags: ["Spirituality", "Personal Growth", "Mindfulness"],
    link: "https://www.amazon.com/Untethered-Soul-Journey-Beyond-Yourself-ebook/dp/B003TU29WA",
    demo: untethered,
  },
];

const services = [
  {
    service: "15 Minute Consultation",
    price: "Free",
  },
  {
    service: "50 Minute Individual Session",
    price: "$140",
  },
  {
    service: "50 Minute Couples Session",
    price: "$225",
  },
  {
    service: "90 Minute Couples Session",
    price: "$300",
  },
];

export { introduction, books, services };
